<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'quoteOrderConfirm' })"
      @prev-step="$router.push({ name: 'quoteOrderDeliver' })"
    ></next-prev-menu>
    <invoice
      :orderDetails="orderDetails"
      :hideSub="true"
      :hideQuote="true"
      :projectOptional="true"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useQuoteOrderStore } from '@/features/quoteOrder/QuoteOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'

export default {
  data() {
    return {}
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    updateOrder(val) {
      this.quoteOrderStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.quoteOrderStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(useQuoteOrderStore),
    orderDetails() {
      return this.quoteOrderStore.orderDetails
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.card {
  // height: 590px;
}
</style>
